import React, { FunctionComponent } from 'react';

import cn from 'classnames';

import css from './styles.css';

type ContentProps = React.HTMLAttributes<HTMLDivElement>;

export const Content: FunctionComponent<ContentProps> = ({ className, ...props }) => {
    const sectionClassname = cn(css.content, className);

    return <div {...props} className={sectionClassname} />;
};

Content.displayName = 'SettingsModal.Content';
